/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerFolders.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Folders
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, November 19, 2018 - 06:07:58 PM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      11/19/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    FOLDER_LIST_CONTAINER_LOADED,
    FOLDER_LIST_CONTAINER_UNLOADED,
    FOLDER_LIST_TABLE_LOADED,
    FOLDER_LIST_TABLE_UNLOADED,

    FOLDER_SELECT_ROW,
    FOLDER_ADD,
    FOLDER_EDIT,
    FOLDER_DELETE,
    FOLDER_OPEN_WARNING,
    FOLDER_CLOSE_WARNING,
    FOLDER_DELETE_DISABLE,

    FOLDER_OPEN_FOLDER,
    FOLDER_CLOSE_FOLDER,
    FOLDER_SELECT_FOLDER,
    FOLDER_OPEN_FOLDER_WARN,
    FOLDER_CLOSE_FOLDER_WARN,
    FOLDER_FOLDER_LOAD, 

    FOLDER_OPEN_DOCUMENT,
    FOLDER_CLOSE_DOCUMENT,
    FOLDER_SELECT_DOCUMENT,
    FOLDER_OPEN_DOCUMENT_WARN,
    FOLDER_CLOSE_DOCUMENT_WARN,
    FOLDER_DOCUMENT_LOAD, 

    FOLDER_OPEN_FILE,
    FOLDER_CLOSE_FILE,
    FOLDER_SELECT_FILE,
    FOLDER_OPEN_FILE_WARN,
    FOLDER_CLOSE_FILE_WARN,
    FOLDER_FILE_LOAD, 

    FOLDER_OPEN_IMAGE,
    FOLDER_CLOSE_IMAGE,
    FOLDER_SELECT_IMAGE,
    FOLDER_OPEN_IMAGE_WARN,
    FOLDER_CLOSE_IMAGE_WARN,
    FOLDER_IMAGE_LOAD, 

    FOLDER_UPDATE_FIELD,
    FOLDER_UPDATE_FILE,

    FOLDER_EDIT_CONTAINER_LOADED,
    FOLDER_EDIT_CONTAINER_UNLOADED,
    FOLDER_EDIT_FORM_LOADED,
    FOLDER_EDIT_FORM_UNLOADED,
    FOLDER_EDIT_DATA_LOAD,
    FOLDER_EDIT_CONTAINER_SUBMIT,
    FOLDER_EDIT_CONTAINER_CANCEL,

    FOLDER_CONTENTS_LOADED
} from '../constants/actionTypeFolders';

const defaultState = {
    refreshList: false,
    danger: false,
    newItem: false,
    folderid: 0,
    name: '',
    description: '',
    createdate: '',
    modifydate: '',
    folder_folderid: 0,
    folder_name: '',
    folder_description: '',
    folder_url: '',
    folder_createdate: '',
    folder_modifydate: '',
    document_contentid: 0,
    document_name: '',
    document_description: '',
    document_content: '',
    document_createdate: '',
    document_modifydate: '',
    file_fileid: 0,
    file_name: '',
    file_description: '',
    file_url: '',
    file_createdate: '',
    file_modifydate: '',
    image_imageid: 0,
    image_name: '',
    image_description: '',
    image_url: '',
    image_createdate: '',
    image_modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case FOLDER_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                folders: action.payload[0] ? action.payload[0].records : null,
                folderTree: action.payload[1] ? action.payload[1].records : null
            }
        case FOLDER_CONTENTS_LOADED:
            return {
                ...state,
                folderContents: action.payload[0] ? action.payload[0].records : null,
                folderid: action.payload[0] ? action.payload[0].folderid : 0
            }
        case FOLDER_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case FOLDER_SELECT_ROW:
            return {
                ...state,
                folderid: action.id
            }
        case FOLDER_ADD:
            return {
                ...state
            }
        case FOLDER_EDIT:
            return {
                ...state,
                folderid: action.id
            }
        case FOLDER_DELETE:
            return {
                ...state,
                folderid: null
            }
        case FOLDER_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case FOLDER_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case FOLDER_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }

        case FOLDER_OPEN_FOLDER:
            return {
                ...state,
                editFolder: true
            }
        case FOLDER_CLOSE_FOLDER:
            return {
                ...state,
                editFolder: false
            }
        case FOLDER_SELECT_FOLDER:
            return {
                ...state,
                folder_folderid: action.id
            }
        case FOLDER_OPEN_FOLDER_WARN:
            return {
                ...state,
                folderDanger: true
            }
        case FOLDER_CLOSE_FOLDER_WARN:
            return {
                ...state,
                folderDanger: false
            }
        case FOLDER_FOLDER_LOAD:
            return {
                ...state,
                folder_folderid: action.payload[0] ? action.payload[0].folderid : 0,
                folder_name: action.payload[0] ? action.payload[0].name : '',
                folder_description: action.payload[0] ? action.payload[0].description : '',
                folder_createdate: action.payload[0] ? action.payload[0].createdate : '',
                folder_modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }

        case FOLDER_OPEN_DOCUMENT:
            return {
                ...state,
                editDocument: true
            }
        case FOLDER_CLOSE_DOCUMENT:
            return {
                ...state,
                editDocument: false
            }
        case FOLDER_SELECT_DOCUMENT:
            return {
                ...state,
                document_contentid: action.id
            }
        case FOLDER_OPEN_DOCUMENT_WARN:
            return {
                ...state,
                documentDanger: true
            }
        case FOLDER_CLOSE_DOCUMENT_WARN:
            return {
                ...state,
                documentDanger: false
            }
        case FOLDER_DOCUMENT_LOAD:
            return {
                ...state,
                document_contentid: action.payload[0] ? action.payload[0].contentid : 0,
                document_name: action.payload[0] ? action.payload[0].name : '',
                document_description: action.payload[0] ? action.payload[0].description : '',
                document_content: action.payload[0] ? action.payload[0].content : '',
                document_createdate: action.payload[0] ? action.payload[0].createdate : '',
                document_modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }

        case FOLDER_OPEN_FILE:
            return {
                ...state,
                editFile: true
            }
        case FOLDER_CLOSE_FILE:
            return {
                ...state,
                editFile: false
            }
        case FOLDER_SELECT_FILE:
            return {
                ...state,
                file_fileid: action.id
            }
        case FOLDER_OPEN_FILE_WARN:
            return {
                ...state,
                fileDanger: true
            }
        case FOLDER_CLOSE_FILE_WARN:
            return {
                ...state,
                fileDanger: false
            }
        case FOLDER_FILE_LOAD:
            return {
                ...state,
                file_fileid: action.payload[0] ? action.payload[0].fileid : 0,
                file_name: action.payload[0] ? action.payload[0].name : '',
                file_description: action.payload[0] ? action.payload[0].description : '',
                file_url: action.payload[0] ? action.payload[0].url : '',
                file_createdate: action.payload[0] ? action.payload[0].createdate : '',
                file_modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }

        case FOLDER_OPEN_IMAGE:
            return {
                ...state,
                editImage: true
            }
        case FOLDER_CLOSE_IMAGE:
            return {
                ...state,
                editImage: false
            }
        case FOLDER_SELECT_IMAGE:
            return {
                ...state,
                image_imageid: action.id
            }
        case FOLDER_OPEN_IMAGE_WARN:
            return {
                ...state,
                imageDanger: true
            }
        case FOLDER_CLOSE_IMAGE_WARN:
            return {
                ...state,
                imageDanger: false
            }
        case FOLDER_IMAGE_LOAD:
            return {
                ...state,
                image_imageid: action.payload[0] ? action.payload[0].imageid : 0,
                image_name: action.payload[0] ? action.payload[0].name : '',
                image_description: action.payload[0] ? action.payload[0].description : '',
                image_url: action.payload[0] ? action.payload[0].url : '',
                image_createdate: action.payload[0] ? action.payload[0].createdate : '',
                image_modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }

        case FOLDER_UPDATE_FIELD:
            return { ...state, [action.key]: action.value };
        case FOLDER_UPDATE_FILE:
            return { ...state, [action.key]: action.value };
        case FOLDER_EDIT_CONTAINER_LOADED:
        case FOLDER_EDIT_DATA_LOAD:
            return {
                ...state,
                folderid: action.payload[0] ? action.payload[0].folderid : 0,
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case FOLDER_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case FOLDER_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case FOLDER_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case FOLDER_LIST_CONTAINER_UNLOADED:
        case FOLDER_LIST_TABLE_UNLOADED:
        case FOLDER_EDIT_CONTAINER_UNLOADED:
        case FOLDER_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerFolders.js